import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const SchemaNameChanged = createAction(
  '[Schemas: Create New]: Schema Name Changed',
  props<{ schemaName: string }>(),
);

export const SchemaCodeChanged = createAction(
  '[Schemas: Create New]: Schema Code Changed',
  props<{ schemaCode: string }>(),
);

export const DefaultCountryChanged = createAction(
  '[Schemas: Create New]: Default Country Changed',
  props<{ defaultCountry: number }>(),
);

export const ExistingCompanyChanged = createAction(
  '[Schemas: Create New]: Existing Company Changed',
  props<{ existingCompany: number }>(),
);

export const CompanyTitleChanged = createAction(
  '[Schemas: Create New]: Company Title Changed',
  props<{ companyTitle: string }>(),
);

export const CountryChanged = createAction(
  '[Schemas: Create New]: Country Changed',
  props<{ country: number }>(),
);

export const TaxOfficeChanged = createAction(
  '[Schemas: Create New]: Tax Office Changed',
  props<{ taxOffice: string }>(),
);

export const VATNumberChanged = createAction(
  '[Schemas: Create New]: VAT Number Changed',
  props<{ vatNumber: string }>(),
);

export const WebSiteChanged = createAction(
  '[Schemas: Create New]: Web Site Changed',
  props<{ webSite: string }>(),
);

export const SchemaLevelChanged = createAction(
  '[Schemas: Create New]: Schema Level Changed',
  props<{ schemaLevel: number }>(),
);

export const NexusAccountChanged = createAction(
  '[Schemas: Create New]: Nexus Account Changed',
  props<{ nexusAccount: number }>(),
);

export const RedemptionTypeChanged = createAction(
  '[Schemas: Create New]: Redemption Type Changed',
  props<{ redemptionType: number }>(),
);

export const RedemptionThresholdChanged = createAction(
  '[Schemas: Create New]: Redemption Threshold Changed',
  props<{ redemptionThreshold: string }>(),
);

export const UsesPrintedCardsChanged = createAction(
  '[Schemas: Create New]: Uses Printed Cards Changed',
);

export const UsesInvoicesChanged = createAction('[Schemas: Create New]: Uses Invoices Changed');

export const TicketForwardingEmailChanged = createAction(
  '[Schemas: Create New]: Ticket Forwarding Email Changed',
  props<{ ticketForwardingEmail: string }>(),
);

export const TicketSenderNameChanged = createAction(
  '[Schemas: Create New]: Ticket Sender Name Changed',
  props<{ ticketSenderName: string }>(),
);

export const WelcomeEmailChanged = createAction(
  '[Schemas: Create New]: Welcome Email Changed',
  props<{ welcomeEmail: string }>(),
);

export const MinimumWKBatchSizeChanged = createAction(
  '[Schemas: Create New]: Minimum WK Batch Size Changed',
  props<{ minimumWKBatchSize: string }>(),
);

export const MaximumWKBatchSizeChanged = createAction(
  '[Schemas: Create New]: Maximum WK Batch Size Changed',
  props<{ maximumWKBatchSize: string }>(),
);

export const PasswordChanged = createAction(
  '[Schemas: Create New]: Password Changed',
  props<{ password: string }>(),
);

export const PasswordVerificationChanged = createAction(
  '[Schemas: Create New]: Password Verification Changed',
  props<{ passwordVerification: string }>(),
);

export const CreateNewCompany = createAction('[Schemas: Create New]: Create New Company');

export const HideCreateNewCompany = createAction('[Schemas: Create New]: Hide Create New Company');

export const CreateSchema = createAction('[Schemas: Create New]: Create Schema');

export const CreateSchemaSuccess = createAction(
  '[Schemas: Create New]: Create Schema Success',
  props<{ res: string }>(),
);

export const CreateSchemaFailed = createAction(
  '[Schemas: Create New]: Create Schema Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const NewCompany = createAction('[Schemas: Create New]: New Company');

export const NewCompanySuccess = createAction(
  '[Schemas: Create New]: New Company Success',
  props<{ res: string }>(),
);

export const NewCompanyFailed = createAction(
  '[Schemas: Create New]: New Company Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const UpdateSchema = createAction('[Schemas: Create New]: Update Schema');

export const UpdateSchemaSuccess = createAction(
  '[Schemas: Create New]: Update Schema Success',
  props<{ res: string }>(),
);

export const UpdateSchemaFailed = createAction(
  '[Schemas: Create New]: Update Schema Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ReloadCompanies = createAction('[Schemas: Create New]: Reload Companies');
